import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MyWeeklyLifeActsComponent } from './myWeeklyLifeActs.component';
import { Shell } from '@app/shell/shell.service';
import { getRoutePath, PlRoute } from '@app/utils/routes';
import { RouteData } from '@app/app-routing.module';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: getRoutePath(PlRoute.lifeActs, false),
      component: MyWeeklyLifeActsComponent,
      data: { handleScrollWithinComponent: true } as RouteData,
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class MyWeeklyLifeActsRoutingModule {}
